import type { ResourceMap } from '../resources/types';
import type { OffersGameData } from '../offers/offersTypes';

export enum IAPProductId {
  CoinPack01 = 'CoinPack01',
  CoinPack02 = 'CoinPack02',
  CoinPack03 = 'CoinPack03',
  CoinPack04 = 'CoinPack04',
  CoinPack05 = 'CoinPack05',
  CoinPack06 = 'CoinPack06',
  BasicBundle01 = 'BasicBundle01',
  BasicBundle02 = 'BasicBundle02',
  BasicBundle03 = 'BasicBundle03',
  BasicBundle04 = 'BasicBundle04',
  BasicBundle05 = 'BasicBundle05',
  UpsellBundle = 'UpsellBundle',
  StarterOffer01 = 'StarterOffer01',
  StarterOffer02 = 'StarterOffer02',
  StarterOffer03 = 'StarterOffer03',
  PiggyBank = 'PiggyBank',
  PiggyBankSilver = 'PiggyBankSilver',
  PiggyBankGold = 'PiggyBankGold',
  PiggyBankOpal = 'PiggyBankOpal',
  PiggyBankDiamond = 'PiggyBankDiamond',
  GoldenStartOffer = 'GoldenStart',
  SeasonPass = 'SeasonPass',
  // legacy offers
  SafetyNet = 'SafetyNet',
  LegacyUpsellOffer = 'LegacyUpsellOffer',
  ShuffleUp = 'ShuffleUp',
  SpinFrenzy = 'SpinFrenzy',
  HammerTime = 'HammerTime',
  Lifeline = 'Lifeline',
}

export enum OfferType {
  CoinPack = 'CoinPack',
  BasicBundle = 'BasicBundle',
  UpsellBundle = 'UpsellBundle',
  StarterOffer = 'StarterOffer',
  PiggyBank = 'PiggyBank',
}

export interface IAPProduct {
  id: string;
  platformId: string;
  currency: string;
  locations: string[];
  data: OffersGameData;
  tags: string[];
  displayName?: string;
  subtitle?: string;
  cornerFlash?: string;
  startDate: number;
  endDate: number | null;
  price: number;
  priceLabel: string;
  rewards: ResourceMap;
  usdCentPrice: number;
  variantId: string;
  activationId: string;
}

export type IAPProductWithPopupData = IAPProduct & {
  data: { popupLayout?: NonNullable<OffersGameData['popupLayout']> };
};

export enum IAPPlacement {
  Shop = 'Shop',
  LevelEnd = 'LevelEnd',
  UpsellOffer = 'UpsellOffer',
  Level = 'Level',
  MainMenu = 'MainMenu',
  AdFallback = 'AdFallback',
}

export interface IAPPlacementData {
  gameArea: string;
  storeEntryPoint: string;
  uiInteractionContext: string;
}

export const iapPlacementData: Record<IAPPlacement, IAPPlacementData> = {
  [IAPPlacement.Shop]: {
    gameArea: 'mainMenuScene',
    storeEntryPoint: 'shop',
    uiInteractionContext: 'mainMenu',
  },
  [IAPPlacement.LevelEnd]: {
    gameArea: 'gameScene',
    storeEntryPoint: 'levelEnd',
    uiInteractionContext: 'levelFail',
  },
  // todo get rid of that
  [IAPPlacement.UpsellOffer]: {
    gameArea: 'upsellOffer',
    storeEntryPoint: 'upsellOffer',
    uiInteractionContext: 'upsell',
  },
  [IAPPlacement.Level]: {
    gameArea: 'gameScene',
    storeEntryPoint: 'level',
    uiInteractionContext: 'level',
  },
  [IAPPlacement.MainMenu]: {
    gameArea: 'mainMenuScene',
    storeEntryPoint: 'mainMenu',
    uiInteractionContext: 'mainMenu',
  },
  [IAPPlacement.AdFallback]: {
    gameArea: 'adFallback',
    storeEntryPoint: 'adFallback',
    uiInteractionContext: 'adFallback',
  },
};

export interface OldPurchaseHistoryEntry {
  usdCentPrice: number;
  offerType: OfferType;
  purchaseDate: number;
}
